import React from "react";
import Card from "./Card";
import { useLocation, useNavigate } from "react-router-dom";

const pageMap = {
  "/home": "Home",
  "/projects": "Projects",
  "/contacts": "Contacts",
  "/dashboard": "Dashboard",
  "/study": "Study"
};

function getBreadcrumb(pathname, projects) {
  if (pathname.startsWith("/projects/")) {
    const slug = pathname.split("/projects/")[1];
    let title = "ProjectDetail";
    if (projects && slug) {
      const project = projects.find(
        (p) => p._id === slug || p.slug === slug
      );
      if (project) title = project.title ? project.title : title;
    }
    return ["Projects", title];
  }

  if (pathname.startsWith("/study/")) {
    const parts = pathname.split("/");
    const sub = parts[2]; // e.g., "spanish", "theology", "cs"

    let subTitle = "";
    if (sub === "spanish") subTitle = "SpanishExam";
    else if (sub === "theology") subTitle = "Theology";
    else if (sub === "cs") subTitle = "CS";
    else if (sub === "math") subTitle = "Math";

    if (subTitle) {
      const breadcrumb = ["Study", subTitle];
      if (sub === "cs") {
        const trackTitles = {
          datascience: "Datascience",
          fullstack: "Fullstack",
          "ai-agent": "AI Agent",
        };
        const track = trackTitles[parts[3]];
        if (track) breadcrumb.push(track);
      }
      if (sub === "math") {
        const section = parts[3];
        const year = parts[4];
        if (section === "theories") breadcrumb.push("Theories");
        if (section === "examination-paper") breadcrumb.push("Examination Paper");
        if (section === "examination-paper" && year) breadcrumb.push(year);
      }
      return breadcrumb;
    }
  }

  const main = Object.keys(pageMap).find((p) => pathname.startsWith(p));
  return main ? [pageMap[main]] : [];
}

function Showcase({ children, projects }) {
  const location = useLocation();
  const navigate = useNavigate();
  const breadcrumb = getBreadcrumb(location.pathname, projects);
  const showBreadcrumb = breadcrumb.length > 0 || location.pathname === "/";
  return (
    <Card extra="flex flex-col w-full" id="showcase">
      {showBreadcrumb && (
        <div className="text-xs px-4 pt-2 pb-1">
          {location.pathname === "/"
            ? <span className="mobile-path-home font-semibold text-lg mr-1 cursor-pointer" onClick={() => navigate("/")}>Home</span>
            : breadcrumb.map((item, idx) => {
              let to = "/";
              if (item === "Projects") to = "/projects";
              else if (item === "Contacts") to = "/contacts";
              else if (item === "Dashboard") to = "/dashboard";
              else if (item === "Study") to = "/study";
              else if (item === "Math") to = "/study/math";
              else if (item === "CS") to = "/study/cs";
              else if (item === "Theories") to = "/study/math/theories";
              else if (item === "Examination Paper") to = "/study/math/examination-paper";
              else if (idx === 1 && location.pathname.startsWith("/projects/")) {
                to = location.pathname;
              }
              else if (idx === breadcrumb.length - 1 && location.pathname.startsWith("/study/")) {
                to = location.pathname;
              }
              return (
                <span
                  key={item}
                  className={
                    idx === 0
                      ? "mobile-path-first font-semibold text-lg mr-1 cursor-pointer"
                      : "mobile-path-second font-semibold text-gray-500 text-sm cursor-pointer"
                  }
                  onClick={() => navigate(to)}
                >
                  {item}
                  {idx < breadcrumb.length - 1 && <span className="mx-1">/</span>}
                </span>
              );
            })}
        </div>
      )}

      <div className="flex flex-col mt-3 min-h-[250px] overflow-y-auto" id="showcase-content">
        {children || <p>Click a nav item to see content here.</p>}
      </div>
    </Card>
  );
}

export default Showcase;
